import React from "react";
import { DateRangePicker } from 'react-date-range';
import Labelbox from "../../helpers/labelbox/labelbox";
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import Button from "@material-ui/core/Button";
import dateformat from 'dateformat';
import "./DateRange.css"
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from "moment";


export default class DateRangeSelect extends React.Component {

    state = {
        item: [{
            startDate: this.props.startDate? this.props.startDate: new Date(),
            endDate: this.props.endDate? this.props.endDate:new Date(),
            key: 'selection',
        }],
        onCount: 1,
        openDateRange: false,
        SelectRange:dateformat(this.props.startDate? this.props.startDate: new Date(), "dd-mmm-yy") + "\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0" + dateformat(this.props.endDate? this.props.endDate:new Date(), "dd-mmm-yy"),
        tabchange:0,
    }
    
    onday = (item) => {
        if (this.state.onCount === 1) {
            this.setState({
                item: [item.selection],
                onCount: this.state.onCount + 1
            })
        } else {
            this.setState({
                item: [item.selection],
                onCount: 1
            })
        }
    }

    OKFUN = () => {
        // if(this.state.onCount===1){
        console.log(this.state.item, "item")
        this.props.rangeDate(this.state.item)
        var startdate = dateformat(this.state.item[0].startDate, "dd-mmm-yy")
        var enddate = dateformat(this.state.item[0].endDate, "dd-mmm-yy")
        this.setState({ SelectRange: startdate + "\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0" + enddate,openDateRange:!this.state.openDateRange })
        // }
    }

    CancelFun = () => {
        this.setState({
            openDateRange:!this.state.openDateRange
        })
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        console.log(newProps, "newProps")
        if(newProps.setselectedDate!==this.state.tabchange){
        this.setState({
            item: [{
                startDate: this.props.startDate? this.props.startDate: new Date(),
                endDate: this.props.endDate? this.props.endDate:new Date(),
                key: 'selection',
            }],
            SelectRange:dateformat(this.props.startDate? this.props.startDate: new Date(), "dd-mmm-yy") + "\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0" + dateformat(this.props.endDate? this.props.endDate:new Date(), "dd-mmm-yy"),
            tabchange:newProps.setselectedDate,
        })
    }
    }
    render() {
        const { t } = this.props;
        console.log(this.state.item, "rangedate")
        return (
            <div style={{zIndex:"1"}}>
                <div className="rangePicker_Master">
                    <div className="rangePicker_Label">
                        Select Range :
            </div>
                    <div className="rangePicker_InpputIconAlign" onClick={()=>this.setState({openDateRange:!this.state.openDateRange})}>
                        <Labelbox
                            className="daterange_calendar"
                            type="text"
                            value={this.state.SelectRange}
                            placeholder={"\xa0" + "Start Date" + "\xa0\xa0\xa0\xa0\xa0" + "-- >" + "\xa0\xa0\xa0\xa0\xa0" + "End Date"} />
                        <InsertInvitationIcon className="rangePicker_Calendericon" />
                    </div>
                </div>
                {this.state.openDateRange && 
                // <div className="rangePicker_positionCenter" onClick={()=>this.props.DateRange()}>
                <div className={`${this.props.dynalign} daterangeMaster`}>
                    <DateRangePicker
                        editableDateInputs={true}
                        onChange={(item) => this.onday(item)}
                        moveRangeOnFirstSelection={false}
                        ranges={this.state.item}
                        // showDateDisplay={false}
                        months={1}
                        direction="horizontal"
                        dateDisplayFormat= "dd-MMM-yy"
                        minDate={this.props.minDate? this.props.minDate:undefined} 
                        maxDate={this.props.maxDate? this.props.maxDate:undefined}                       
                    />
                    <div className="rangePicker_btncontainer">
                        <Button className="rangePicker_cancelbtn" onClick={this.CancelFun}>Cancel</Button>
                        <Button className="rangePicker_okbtn" onClick={this.OKFUN}>Ok</Button>
                    </div>
                </div>
                // </div>
                }
            </div>
        )
    }
}